import telegramUser from './telegram-user';
import telegramGroup from './telegram-group';
import telegramBot from './telegram-bot';
import telegramLink from './telegram-link';
import botMessageTemplate from './bot-message-template';
import telegramNotification from './telegram-notification';
import telegramUserActivity from './telegram-user-activity';


export default {
  'telegram-user': telegramUser,
  'telegram-group': telegramGroup,
  'telegram-bot': telegramBot,
  'telegram-link': telegramLink,
  'bot-message-template': botMessageTemplate,
  'telegram-notification': telegramNotification,
  'telegram-user-activity': telegramUserActivity,
};
